var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c(
      "div",
      {
        staticClass: "row p-3 mt-2 shadow-sm bg-white",
        class: { selected: _vm.receipt.comprobanteId === _vm.selectedReceipt }
      },
      [
        _c("div", { staticClass: "col-11", attrs: { "data-cy": "file" } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-2 text-center text-primary" },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Folio",
                        expression: "'Folio'"
                      }
                    ],
                    staticClass: "cursor-pointer",
                    class: { "text-success": _vm.wasCopied }
                  },
                  [_vm._v(" " + _vm._s(_vm.receipt.folio) + " ")]
                ),
                _vm.showCheck
                  ? _c("b-form-checkbox", {
                      on: { change: _vm.selectElement },
                      model: {
                        value: _vm.receipt.selected,
                        callback: function($$v) {
                          _vm.$set(_vm.receipt, "selected", $$v)
                        },
                        expression: "receipt.selected"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-2" },
              [
                _vm.receiptsStates[_vm.receipt.estado]
                  ? _c(
                      "vs-chip",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value:
                              "" + _vm.receiptsStates[_vm.receipt.estado].label,
                            expression:
                              "`${receiptsStates[receipt.estado].label}`"
                          }
                        ],
                        attrs: {
                          color: _vm.receiptsStates[_vm.receipt.estado].color
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.receiptsStates[_vm.receipt.estado].label
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-8" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-3" }, [
                  _vm._v(" " + _vm._s(_vm.receipt.adjudicatarios.nombre) + " "),
                  _c("br"),
                  _c("small", [_vm._v(_vm._s(_vm.receipt.adjudicatarios.rut))])
                ]),
                _c("div", { staticClass: "col-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("dateFormat")(_vm.receipt.fechaCreacion)) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "col-5" }, [
                  _vm._v(
                    " " + _vm._s(_vm.receipt.subasta.gestora.razonSocial) + " "
                  ),
                  _c("br"),
                  _c("small", [
                    _vm._v(" " + _vm._s(_vm.receipt.subasta.gestora.rut) + " ")
                  ])
                ]),
                _c("div", { staticClass: "col-2" }, [
                  _c("b", [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("amount")(_vm.receipt.montoTotal)) +
                        " "
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-11 offset-1" },
              [
                _c(
                  "vs-chip",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Folio Subasta",
                        expression: "'Folio Subasta'"
                      }
                    ],
                    staticClass: "mr-4",
                    attrs: { color: "primary" }
                  },
                  [
                    _c("vs-avatar", { attrs: { icon: "gavel" } }),
                    _vm._v(" " + _vm._s(_vm.receipt.subasta.folio) + " ")
                  ],
                  1
                ),
                _c(
                  "vs-chip",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Folio Lote",
                        expression: "'Folio Lote'"
                      }
                    ],
                    staticClass: "mr-4",
                    attrs: { color: "green" }
                  },
                  [
                    _c("vs-avatar", { attrs: { icon: "local_offer" } }),
                    _vm._v(" " + _vm._s(_vm.receipt.lote.folio) + " ")
                  ],
                  1
                ),
                _c(
                  "vs-chip",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Posición Subasta",
                        expression: "'Posición Subasta'"
                      }
                    ],
                    staticClass: "mr-4",
                    attrs: { color: "primary" }
                  },
                  [
                    _c("vs-avatar", { attrs: { icon: "location_on" } }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.receipt.lote.loteadora.codigo +
                            " -" +
                            _vm.receipt.subasta.gestora.codigoAduana +
                            " -" +
                            _vm.receipt.lote.folio +
                            "-" +
                            _vm.receipt.lote.posicion
                        ) +
                        " "
                    )
                  ],
                  1
                ),
                _c(
                  "vs-chip",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Monto de garantía",
                        expression: "'Monto de garantía'"
                      }
                    ],
                    staticClass: "mr-4",
                    attrs: { color: "#7d84ad" }
                  },
                  [
                    _c("vs-avatar", { attrs: { icon: "monetization_on" } }),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("amount")(_vm.receipt.garantiaMonto)) +
                        " "
                    )
                  ],
                  1
                ),
                _vm.receipt.fechaMaximaPago
                  ? _c(
                      "vs-chip",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Fecha máxima de pago",
                            expression: "'Fecha máxima de pago'"
                          }
                        ],
                        staticClass: "mr-4",
                        attrs: { color: "#ff9800" }
                      },
                      [
                        _c("vs-avatar", { attrs: { icon: "date_range" } }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormat")(_vm.receipt.fechaMaximaPago)
                            ) +
                            " "
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-1 d-flex justify-center" },
          [
            _vm._t(
              "actions",
              [
                _c("ReceiptsOptions", {
                  ref: "file-options-" + _vm.receipt.comprobanteId,
                  attrs: {
                    receipt: _vm.receipt,
                    "select-receipt": _vm.selectReceipt
                  },
                  on: { "reload-list": _vm.handleReloadList }
                })
              ],
              { receipt: _vm.receipt }
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }